import gql from "graphql-tag";
// import _ from "lodash";
import { User } from "../../store/store";
import { QueryDto } from "../../../../types/types";

import { Apollo } from "@/decorators";

import USER_EDITION from "../../graphql/user/UserEdition.gql";
import UPSERT_USER from "../../graphql/user/UpsertUserDetails.gql";
import UPSERT_SUB_USERS from "../../graphql/user/UpsertSubUsers.gql";
import UPDATE_SUB_USER from "../../graphql/user/UpdateSubUser.gql";

import UPDATE_ACCOUNTING_WORKSPACES_OF_USER from "../../graphql/accountingWorkspace/UpdateAccountingWorkspacesOfUser.gql";

// import UPSERT_USER_PROFILE from "../../graphql/user/UpsertUserProfile.gql";
// import PROFILES from "../../graphql/profiles/Profiles.gql"
import REFERENCE_PROFILES from "../../graphql/profiles/ReferenceProfiles.gql";
import MODIFY_USER_STATUS from "../../graphql/user/ModifyUserStatus.gql";

import { emailPattern } from "../../services/emailServices";
import { getProfileName } from "../../services/profile";
import {
    checkIBAN,
    checkBIC,
    getBICFromIBAN,
    onIbanChanged,
    getBankNameFromIban,
} from "../../../../backend/src/common/bankAccount/bankAccountServices";
import { updateStoreUser } from "@/services/userServices";
import getEnv from "@/env";
import { getDBFormattedDate } from "@/services/dateServices";
import { getDisplayEmail } from "../../services/emailServices";
import { Component, Vue } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";

import { getUserDisplayName } from "../../services/userServices";

import CHECK_USER_EMAIL from "../../graphql/user/CheckEmail.gql";
import SEND_RECOVERY_CODE from "../../graphql/user/SendRecoveryCode.gql";
// import RESEND_SIGNUP_EMAIL from "../../graphql/auth/ResendSignupEmail.gql"
import { truncateInput } from "../../helpers/formInput.helper";
import { DialogAction } from "../../services/dialogAction";
import { getSiretValue } from "../../services/companyServices";

import emitter from "@/services/emitter";

const env = getEnv();

@Component({
    emits: ["user-upserted", "user"],
})
export class UserBase extends Vue {
    @Prop({ default: null }) id: string;
    @Prop({ default: null }) actions: {
        action: DialogAction;
    };

    get emailPattern() {
        return emailPattern;
    }
    // emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    forcedWithAccountPerson = false;

    searchCompany = "";

    searchAccountingFirm = "";

    searchAccountingWorkspace = "";

    password: string = "";
    displayPassword: boolean = false;

    forcedWithAccountUser = false;

    isUserWithAccount = false;
    initialValueUserWithAccount = false;

    formIsValid: boolean = false;

    // accountingFirmsOfUser:any = []

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    subUsers: any = [];

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    accountingWorkspacesOfUser: any = [];

    get typesList() {
        const types = [
            { value: "NATURAL_PERSON", text: "Personne physique" },
            { value: "LEGAL_PERSON", text: "Personne morale" },
        ];
        if (this.user.type === "API_USER") {
            types.push({ value: "API_USER", text: "API" });
        }
        return types;
    }

    legalForms = [
        { id: "ASSO", name: "Association" },
        { id: "CE", name: "Comité d'entreprise" },
        { id: "CL", name: "Collectivité locale" },
        { id: "CNE", name: "Commune" },
        { id: "COOP", name: "Coopérative" },
        { id: "CUMA", name: "Coopérative d'utilisation de matériel agricole" },
        { id: "DPT", name: "Département" },
        { id: "EARL", name: "Exploitation agricole à responsabilité limitée" },
        { id: "EC", name: "Entreprise collective" },
        { id: "EI", name: "Entreprise individuelle" },
        { id: "EIRL", name: "Entreprise individuelle à responsabilité limitée" },
        { id: "ETRANGER", name: "Personne morale de droit étranger" },
        { id: "EURL", name: "Entreprise unipersonnelle à responsabilité limitée" },
        { id: "FEDE", name: "Fédération" },
        { id: "FOND", name: "Fondation" },
        { id: "GAEC", name: "Groupement agricole d'exploitation en commun" },
        { id: "GEIE", name: "Groupement européen d'intérêt économique" },
        { id: "GF", name: "Groupement forestier" },
        { id: "GFA", name: "Groupement foncier agricole" },
        { id: "GFR", name: "Groupement foncier rural" },
        { id: "GIE", name: "Groupement d'intérêt économique" },
        { id: "GPT", name: "Groupement" },
        { id: "GREFFE", name: "Greffe" },
        { id: "IND", name: "Indivision" },
        { id: "MUT", name: "Mutuelle" },
        { id: "SA", name: "Société anonyme" },
        { id: "SAE", name: "Société anonyme d'exploitation" },
        { id: "SARL", name: "Société à responsabilité limitée" },
        { id: "SELARL", name: "Société d'exercice libéral à responsabilité limitée" },
        { id: "SAS", name: "Société anonyme par actions simplifiée" },
        { id: "SASU", name: "SASU" },
        { id: "SC", name: "Société civile (autre que infra)" },
        { id: "SCA", name: "Société en commandite par actions" },
        { id: "SCCV", name: "Société civile de construction vente" },
        { id: "SCE", name: "Société civile d'exploitation" },
        { id: "SCEA", name: "Société civile d'exploitation agricole" },
        { id: "SCEV", name: "Société civile d'exploitation vinicole" },
        { id: "SCH", name: "Société civile holding" },
        { id: "SCI", name: "Société civile immobilière" },
        { id: "SCM", name: "Société civile de moyens" },
        { id: "SCP", name: "Société civile professionnelle" },
        { id: "SCPG", name: "Société civile participation gestion" },
        { id: "SCPI", name: "Société civile de placement collectif immobilier" },
        { id: "SCS", name: "Société en commandite simple" },
        { id: "SCVV", name: "Société civile de vente volontaire" },
        { id: "SDE", name: "Société de droit étranger" },
        { id: "SNC", name: "Société en nom collectif" },
    ];

    defaultUser = {
        id: "",
        type: "NATURAL_PERSON",
        email: "",
        emailSubscription: "",
        // password: "",
        firstname: "",
        lastname: "",
        marriedName: "",
        company: {
            id: "",
            name: "",
        },
        profile: {
            id: "",
            name: "",
            clients: [],
            // accessRights:[],
            configuration: {
                outstanding: {
                    client: false,
                    selectionClient: false,
                    supplier: false,
                    expenseReport: false,
                    salary: false,
                },
                // payments: {
                //     supplier: false,
                //     expenseReport: false,
                //     salary: false
                // },
                // validation: {
                //     supplier: false,
                // }
            },
        },
        externalId: null,
        availableCompanies: [],
        hourlyCost: 0,
        isSubUserOf: null,
        subUsers: [],
    };

    get userId() {
        if (this.$route.name === "companyEdition") return null;
        return this.id || this.$route.params.id;
    }

    get companyId() {
        // if (this.$route.name === 'create-accounting-user') return this.$store.state.user.company.id
        // return this.$route.params.companyId || this.$store.state.selected_company?.id || null
        if (this.$route.params.companyId) {
            return this.$route.params.companyId;
        }
        if (this.user?.company?.id) {
            return this.user?.company?.id;
        }
        if (this.$store.state.selected_company?.id) {
            return this.$store.state.selected_company?.id;
        }
        return null;
    }

    get inAdmin() {
        return this.$store.state.inAdmin;
    }

    // get isUserCreationMode() {
    //     if (this.$route.name === 'create-user') {
    //         return true
    //     }
    //     return false
    // }

    get gainOrLossReadRight() {
        return this.currentUser?.profile?.configuration?.gainOrLoss?.read;
    }

    get gainOrLossWriteRight() {
        return this.currentUser?.profile?.configuration?.gainOrLoss?.write;
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    get isAccountingCurrentUser() {
        return this.currentUser.isAccountingUser;
    }

    get isLegalPerson() {
        return this.user?.type === "LEGAL_PERSON";
    }

    get isPasswordRequired() {
        if (!this.isUserWithAccount) return false;
        if (!this.user.id) {
            return true;
        }
        if (!this?.currentUser?.profile) {
            return false;
        }
        if (
            (this.currentUser.profile.type === "ROOT" ||
                this.currentUser.profile.type === "ACCOUNTING") &&
            !this.initialValueUserWithAccount
        ) {
            return true;
        }
        return this.currentUser.profile.restrictionLevel === 1 && !this.initialValueUserWithAccount;
    }

    profileUserIsSetInDB: boolean = false;
    initialCustomProfile: boolean = false;
    userQueryDone: boolean = false;

    profileId_: string = null;

    get profileId() {
        if (this.user?.profile?.id) {
            return this.user.profile.id;
        }
        return this.profileId_;
    }

    set profileId(value) {
        if (this.user?.profile) {
            this.user.profile.id = value;
        }
        this.profileId_ = value;
    }

    get legalForm() {
        if (this.company?.legalForm) {
            return this.company.legalForm;
        }
        return "";
    }

    get loading() {
        if (this.$apollo.queries.user) {
            return this.$apollo.queries.user.loading;
        }
        return false;
    }

    get isInInternalManagement() {
        return this.$route.path.includes("admin");
    }

    @Apollo({
        query: USER_EDITION,
        variables() {
            return { id: this.userId };
        },
        fetchPolicy: "network-only",
        skip() {
            return !this.userId;
        },
        specificResult({ data, loading }: QueryDto) {
            if (!loading) {
                if (data) {
                    if (data.user) {
                        // const user = JSON.parse(JSON.stringify(data.user))
                        const user = data.user;
                        if (!user.profile) {
                            this.profileUserIsSetInDB = false;
                            this.initialCustomProfile = false;
                            user.profile = {
                                id: "",
                                name: "",
                            };
                        } else {
                            this.profileUserIsSetInDB = true;
                        }

                        // debugger
                        this.isUserWithAccount = user.isEnable;
                        this.initialValueUserWithAccount = user.isEnable;

                        let selectedBankAccount = {
                            name: "",
                            iban: "",
                            bic: "",
                        };
                        if (user.bankAccounts?.length) {
                            selectedBankAccount = user.bankAccounts[0];
                        } else if (user.iban) {
                            selectedBankAccount.iban = user.iban;
                        }
                        if (!selectedBankAccount.name && selectedBankAccount.iban) {
                            selectedBankAccount.name = getBankNameFromIban(
                                selectedBankAccount.iban,
                            );
                        }
                        if (!selectedBankAccount.bic && selectedBankAccount.iban) {
                            selectedBankAccount.bic = getBICFromIBAN(selectedBankAccount.iban);
                        }
                        this.selectedBankAccount = selectedBankAccount;

                        if (user.subUsers?.length) {
                            // debugger
                            this.subUsers = user.subUsers.map((sU) => sU.id);
                        } else {
                            this.subUsers = [];
                        }
                        if (!user.externalId) {
                            user.externalId = null;
                        }
                        this.user = user;
                        this.setContactEmail(this.user.email);
                        this.updateOtherCompanies();
                    } else {
                        this.user = JSON.parse(JSON.stringify(this.defaultUser));
                        this.selectedBankAccount = {
                            iban: "",
                            bic: "",
                        };
                        // this.newUser()
                    }
                    this.userQueryDone = true;
                }
            }
        },
    })
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    user: any = {
        id: "",
        type: "NATURAL_PERSON",
        email: "",
        emailSubscription: "",
        password: "",
        firstname: "",
        lastname: "",
        marriedName: "",
        birthDate: "",
        birthDepartment: "",
        birthPlace: "",
        birthCountry: "",
        company: {
            id: "",
            name: "",
            shareCapital: null,
        },
        profile: {
            id: "",
            name: "",
            referenceProfile: null,
            clients: [],
            // accessRights: [],
            configuration: {
                outstanding: {
                    client: false,
                    selectionClient: false,
                    supplier: false,
                    expenseReport: false,
                    salary: false,
                },
                // payments: {
                //     supplier: false,
                //     expenseReport: false,
                //     salary: false
                // },
                // validation: {
                //     supplier: false,
                // }
            },
        },
        externalId: null,
        availableCompanies: [],
        hourlyCost: 0,
        siret: "",
        legalForm: "",
        subUsers: [],
    };

    // @Apollo({
    //     query: ACCOUNTING_FIRMS_USER,
    //     variables() {
    //         return { userId: this.userId }
    //     },
    //     skip() {
    //         return !this.userId
    //     },
    //     specificResult({ data, loading, networkStatus }: any) {
    //         if (!loading) {
    //             if (data) {
    //                 if (data.companies) {
    //                     this.accountingFirmsOfUser = data.companies.map((company) => company.id)
    //                     this.accountingFirmsOfUserDB = data.companies.map((company) => company.id)
    //                 }
    //             } else {
    //                 debugger
    //             }
    //         }
    //     }
    // })
    // accountingFirmsOfUserDB: any = {
    //     id: "",
    // }

    selectedBankAccount = {
        name: "",
        iban: "",
        bic: "",
    };

    refresh() {
        if (this.$apollo.queries.user?.refresh) {
            this.$apollo.queries.user.refetch();
        }
    }

    isOwner(user, company) {
        if (user) {
            const userWithRoles = company.companyUsers.filter((cu) => cu.role);
            if (userWithRoles?.length) {
                return !!userWithRoles.find((cu) => cu.user?.id === user.id);
            }
        }
        return false;
    }

    hasRight(company) {
        const userWithRoles = company.companyUsers?.filter((cu) => cu.role && cu.user);
        if (userWithRoles?.length) {
            return !!userWithRoles.find((cu) => cu.user.id === this.currentUser.id);
        }
        if (!this.currentUser.profile) {
            return false;
        }
        if (this.currentUser.isAccountingEmployee) {
            return !!this.currentUser.allAvailableCompanies?.find((ac) => ac.id === company.id);
        }
        return true;
    }

    @Apollo({
        query: gql`
            query UserCompany($id: ID!) {
                company(where: { id: $id }) {
                    id
                    name
                    siren
                    accountingFirm
                    clientCompaniesToAccountingFirms {
                        id
                        name
                        siret
                        siren
                    }
                    companyUsers {
                        id
                        user {
                            id
                            firstname
                            lastname
                        }
                        role
                    }
                    legalForm
                    clientCompanies {
                        id
                    }
                }
            }
        `,
        variables() {
            return { id: this.companyId };
        },
        skip() {
            return !this.companyId;
        },
        specificResult({ data, loading }: QueryDto) {
            if (!loading) {
                if (data && data.company && data.company) {
                    this.company = data.company;
                    if (!this.userId) {
                        this.user.company = this.company;
                        if (
                            this.currentUser.company.id !== this.companyId ||
                            !this.company.accountingFirm
                        ) {
                            this.user.availableCompanies = [this.company];
                        } else {
                            this.user.availableCompanies = [];
                        }
                    }
                } else {
                    this.user.company = { id: "", name: "" };
                    this.user.availableCompanies = [];
                }
            }
        },
    })
    company = null;

    @Apollo({
        query: REFERENCE_PROFILES,
        variables() {
            return {
                companyId: this.user.company.id,
            };
        },
        skip() {
            return !!this.userId && !this.userQueryDone;
        },
        specificResult({ data, loading }: QueryDto) {
            if (!loading) {
                if (data && data.profiles) {
                    data.profiles.sort((a, b) => {
                        if (this.$t("profiles.name." + a.name) < this.$t("profiles.name." + b.name))
                            return -1;
                        if (this.$t("profiles.name." + a.name) > this.$t("profiles.name." + b.name))
                            return 1;
                        return 0;
                    });

                    this.availableProfiles = data.profiles;
                }
            }
        },
    })
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    availableProfiles: any = [];

    getProfileName(profile) {
        if (profile) {
            return getProfileName(this, profile);
        }
        return "XXXX";
    }
    getDisplayEmail(email) {
        return getDisplayEmail(email);
    }

    isAvailableCompanies(companyId) {
        const companyIndex = this.user.availableCompanies.findIndex((x) => x.id === companyId);
        if (companyIndex !== -1) {
            return true;
        }
        return false;
    }

    get isValid() {
        if (this.loading) return false;
        // debugger
        if (!this.formIsValid) return false;
        if (this.user.type === "NATURAL_PERSON") {
            // if (!this.user.firstname) return false
            if (!this.user.lastname) return false;
            if (!this.user.company?.id) return false;

            if (this.isUserWithAccount) {
                if (!this.profileId) return false;
            }
            // if (this.user.email) {
            //     if (!this.user?.profile?.referenceProfile?.id) {
            //         return false
            //     }
            // }
        } else {
            // if (!this.user.legalForm) return false
            // if (!this.user.siret) return false
            if (!this.user.lastname) return false;
            if (!this.user.company || !this.user.company.id) return false;
        }

        return true;
    }

    upsertLoading: boolean = false;

    async upsertUser(redirect = true) {
        if (!this.isValid) return;
        this.upsertLoading = true;
        let availableCompanies = [];
        if (this.isUserWithAccount || this.user.type === "API_USER") {
            availableCompanies = this.user.availableCompanies.map((company) => ({
                id: company.id,
            }));
        }
        let result = null;

        const password = null;

        try {
            let createProfile = undefined;
            let updateProfile = undefined;

            const upsertProfile =
                this.user.type === "NATURAL_PERSON" || this.user.type === "API_USER";
            if (upsertProfile) {
                const profileId = this.profileId;
                const connectProfile = profileId ? { connect: { id: profileId } } : undefined;
                createProfile = connectProfile;
                updateProfile = connectProfile;
            } else {
                const disconnectProfile = this.initialCustomProfile
                    ? { delete: true }
                    : { disconnect: true };
                updateProfile = this.profileUserIsSetInDB ? disconnectProfile : undefined;
            }

            // if (!this.$refs?.profileEdition) {
            //     const profileId = this.user.profile?.id || this.user.profile?.referenceProfile?.id
            //     const connectProfile = this.isUserWithAccount && profileId ? { connect: { id: profileId } } : undefined
            //     createProfile = this.isUserWithAccount && this.user.type === 'NATURAL_PERSON' ? connectProfile : undefined
            //     updateProfile = this.isUserWithAccount && this.user.type === 'NATURAL_PERSON' ? connectProfile : this.profileUserIsSetInDB ? disconnectProfile : undefined
            // } else if (!this.isUserWithAccount && this.profileUserIsSetInDB) {
            //     updateProfile = disconnectProfile
            // }
            let bankAccounts;

            if (this.selectedBankAccount.iban || this.selectedBankAccount.bic) {
                bankAccounts = [this.selectedBankAccount];
            }

            result = await this.$apollo.mutate({
                mutation: UPSERT_USER,
                variables: {
                    id: this.user.id || "",
                    type: this.user.type,
                    email: this.isUserWithAccount ? this.user.email : null,
                    emailSubscription: this.user.emailSubscription,
                    firstname: this.isLegalPerson ? undefined : this.user.firstname?.trim() || "",
                    lastname: this.user.lastname?.trim() || "",
                    marriedName: this.user.marriedName?.trim() || "",
                    companyId: this.user.company.id,
                    availableCompanies,
                    createProfile,
                    updateProfile,
                    hourlyCost: this.user.hourlyCost,
                    birthDate: this.user.birthDate ? getDBFormattedDate(this.user.birthDate) : null,
                    birthDepartment: this.user.birthDepartment,
                    birthPlace: this.user.birthPlace,
                    birthCountry: this.user.birthCountry,
                    address: this.user.address,
                    addressComplement: this.user.addressComplement,
                    postalCode: this.user.postalCode,
                    city: this.user.city,
                    country: this.user.country,
                    phoneNumber: this.user.phoneNumber,
                    civility: this.user.civility,
                    siret: this.user.siret,
                    legalForm: this.user.legalForm ? this.user.legalForm : null,
                    iban: null,
                    bankAccounts,
                    password,
                    externalId:
                        this.isUserWithAccount && this.user?.externalId
                            ? this.user.externalId
                            : null,
                },
            });
            const newUser = this.user.id === "";
            if (newUser) {
                if (result?.data?.upsertUser?.id !== "") {
                    this.user.id = result.data.upsertUser.id;
                } else {
                    return;
                }
            }
            if (upsertProfile) {
                if (this.$refs?.profileEdition) {
                    await this.$refs.profileEdition.upsert();
                    await this.$refs.profileEdition.refetchCompanyUser();
                }
            }
            // debugger
            if (this.$refs?.investmentEdition) {
                await this.$refs.investmentEdition.upsert();
            }

            this.updateOtherCompanies();
            await this.upsertOtherCompanies();

            // if(this.isUserWithAccount || this.company.legalForm === "SCI") {
            //      if (this.$refs?.investmentEdition) {
            //         // @ts-ignore
            //         await this.$refs.investmentEdition.upsert()
            //     } else {
            //         debugger
            //     }
            // }

            await this.upsertSubUsers();
            await this.updateAccountingWorkspacesOfUser();
            await this.modifyAccount();

            if (this.user.id === this.currentUser.id) {
                await updateStoreUser(this.$apollo, this.$store, this.currentUser.id);
            }

            if (newUser && redirect) {
                this.$router.replace({
                    name: this.inAdmin ? "admin-users-details" : "users-details",
                    params: { id: `${this.user.id}` },
                });
            } else {
                this.$emit("user-upserted");
                this.$emit("user", this.user);
                this.refresh();
            }

            this.upsertLoading = false;
        } catch (e) {
            console.error(e);
            return;
        }
    }

    updateOtherCompanies() {}
    upsertOtherCompanies() {}

    //
    // user accountingFirms
    //
    @Watch("initialUserAccountingFirmIds")
    onInitialUserAccountingFirmIdsChanged() {
        this.userAccountingFirmIds = this.initialUserAccountingFirmIds;
    }

    userAccountingFirmIds = [];

    get initialUserAccountingFirmIds() {
        // debugger
        if (this.parentUser.subUsers?.length) {
            if (this.parentUser.company?.id) {
                const userAccountingFirmIds = [this.parentUser.company.id];
                if (this.parentUser.subUsers) {
                    userAccountingFirmIds.push(
                        ...this.parentUser.subUsers.map((su) => su.company.id),
                    );
                }
                return userAccountingFirmIds;
            }
        }
        return [];
    }

    //

    async upsertSubUsers() {
        //
        // A REVOIR : IL FAUT UNE SEUL RESOLVER APPELE UNE FOIS
        // ON ENVOIE QUE la liste de userAccountingFirmIds et c'est le back qui fait tout
        //

        if (this.parentUser?.id) {
            // debugger

            await this.$apollo.mutate({
                mutation: UPSERT_SUB_USERS,
                variables: {
                    parentUserId: this.parentUser.id,
                    userAccountingFirmIds: this.userAccountingFirmIds,
                    initialUserAccountingFirmIds: this.initialUserAccountingFirmIds,
                },
            });
        } else {
            // eslint-disable-next-line no-debugger
            debugger;
        }
    }

    async updateSubUser() {
        if (this.user?.id) {
            await this.updateSubUserProfile();
            await this.updateAccountingWorkspacesOfUser();
        }
    }

    async updateSubUserProfile() {
        if (this.user?.id) {
            const profileId = this.profileId;

            let availableCompanies = [];
            if (this.isUserWithAccount) {
                availableCompanies = this.user.availableCompanies.map((company) => ({
                    id: company.id,
                }));
            }

            if (profileId) {
                await this.$apollo.mutate({
                    mutation: UPDATE_SUB_USER,
                    variables: {
                        userId: this.user.id,
                        profileId,
                        availableCompanies,
                    },
                });
                if (this.$refs?.profileEdition) {
                    await this.$refs.profileEdition.upsert();
                }
            }
        }
    }

    async updateAccountingWorkspacesOfUser() {
        if (this.user?.id) {
            await this.$apollo.mutate({
                mutation: UPDATE_ACCOUNTING_WORKSPACES_OF_USER,
                variables: {
                    userId: this.user.id,
                    accountingWorkspaces: this.accountingWorkspacesOfUser,
                },
            });
        }
    }

    setContactEmail(email: string) {
        //  Manage contact email and login email
        if (!this.user.emailSubscription && email) {
            //  Pre-fill contact email field if empty
            this.user.emailSubscription = email;
        }
    }

    @Watch("user.emailSubscription")
    onEmailSubscriptionChanged() {
        if (!this.isUserWithAccount && this.user?.emailSubscription) {
            this.user.email = this.user.emailSubscription;
        }
    }

    onChangeType() {
        if (this.user.type === "LEGAL_PERSON") {
            this.user.firstname = null;
            this.user.email = null;
            this.user.civility = null;
            this.user.birthDate = null;
            this.user.birthDepartment = null;
            this.user.birthPlace = null;
            this.user.birthCountry = null;
            this.user.availableCompanies = [];
            this.user.externalId = null;
            this.isUserWithAccount = false;
        } else {
            this.user.siret = null;
            this.user.legalForm = null;
        }
    }

    get currentUserIsSubUser() {
        if (this.currentUser.isSubUserOf?.id) {
            return true;
        }

        return false;
    }

    get userIsSubUser() {
        // debugger

        if (this.user.isSubUserOf?.id) {
            return true;
        }

        return false;
    }

    back() {
        debugger;
        this.$router.go(-1);
    }

    get rules() {
        return {
            notEmpty: (value) => {
                return !!value || this.$t("settings.itemRequired");
            },
            checkIBAN: (value) => {
                return !value || checkIBAN(value) || this.$t("settings.wrongIBAN");
            },
            checkBIC: (value) => {
                return !value || checkBIC(value) || this.$t("settings.wrongBIC");
            },
        };
    }

    onIbanChanged(bankAccount) {
        onIbanChanged(bankAccount);
    }

    async modifyAccount() {
        if (!this.user.id) {
            return;
        }
        if (!this.isUserWithAccount) {
            await this.$apollo.mutate({
                mutation: MODIFY_USER_STATUS,
                variables: {
                    userId: this.user.id,
                    companyId: this.company.id,
                    status: "DISABLE",
                },
            });
        } else {
            await this.$apollo.mutate({
                mutation: MODIFY_USER_STATUS,
                variables: {
                    userId: this.user.id,
                    companyId: this.company.id,
                    status: "ENABLE",
                },
            });
        }
    }
    // get parentCurrentUser() {
    //      if (this.currentUser?.isSubUserOf) {
    //         return this.currentUser?.isSubUserOf
    //     }
    //     return this.currentUser
    // }

    // get availableAccountingFirms() {
    //     if (this.parentUser?.company.id) {
    //         const allAccountingFirms = []
    //         if (this.parentUser?.company.id === this.parentCurrentUser.company.id) {
    //             allAccountingFirms.push(this.parentCurrentUser.company)
    //         }
    //         if (this.parentCurrentUser.company?.accountingFirms) {
    //             allAccountingFirms.push(this.parentCurrentUser.company?.accountingFirms)
    //         }
    //         return allAccountingFirms
    //     }
    //     return []
    // }

    get parentUser() {
        if (this.user?.isSubUserOf?.id) {
            return this.user?.isSubUserOf;
        }
        return this.user;
    }

    get accountingFirmId() {
        if (this.company) {
            if (this.company.clientCompaniesToAccountingFirms?.length) {
                for (const accountingFirm of this.company.clientCompaniesToAccountingFirms) {
                    if (accountingFirm.siren === "844122648") {
                        continue;
                    }
                    return accountingFirm.id;
                }
                // if (this.company.accountingFirm) {
                return this.company.id;
                // }
            } else if (this.company.siren !== "844122648" && this.company.clientCompanies?.length) {
                return this.company.id;
            } else if (this.company.accountingFirm) {
                // debugger
                // should never happen : contact Eric
                return this.company.id;
            }
        }

        return null;
    }

    // bobbee business
    get isAutonomousCompany() {
        if (this.accountingFirmId) {
            return false;
        }
        return true;
    }

    async deleteUser() {
        await this.$apollo.mutate({
            mutation: MODIFY_USER_STATUS,
            variables: {
                userId: this.user.id,
                status: "DELETE",
            },
        });
    }

    userGenerateEmailText: string = "Générer un nouveau mail de connexion";
    selectedMenu = "personal";

    // dialogSelectCompany = false;

    windowStep = "createUser";
    profileEditionTab = "profileEdition";

    // dialogDisconnectUser = false;

    confirmPassword: string = "";

    refreshKey = 0;

    get rulesSiret() {
        return [
            (v) => !!v || this.$t("settings.itemRequired"),
            (v) => !!(v || "").match(/^[0-9]{14}$/) || this.$t("settings.isNotSiret"),
        ];
    }

    get showIban() {
        return (
            this.isAccountingCurrentUser ||
            this.currentUser.profile?.name?.includes("customer-admin") ||
            this.user?.id === this.currentUser.id
        );
    }

    /**
     * Checks if the user is coming from the "/me/users" menu.
     * @returns {boolean} `true` if the previous route ends with "/me/users", otherwise `false`.
     */
    get isFromUsersMenu(): boolean {
        const previousRoute = this.$router.options.history.state.back as string;
        return previousRoute && previousRoute.endsWith("/me/users");
    }

    onInputSetTruncatedIban() {
        this.selectedBankAccount.iban = truncateInput(this.selectedBankAccount.iban, 34);
    }

    onInputSetTruncatedSiret() {
        this.user.siret = truncateInput(this.user.siret, 14);
    }

    getUserDisplayName(user) {
        return getUserDisplayName(user);
    }

    setSelectedMenu(text) {
        this.selectedMenu = text;
    }

    beforeMount() {
        //
        if (!this.user?.company?.id && this.companyId) {
            const currentCompany = this.currentUser.allAvailableCompanies.find(
                (x) => x.id === this.companyId,
            );
            if (currentCompany) {
                this.user.company = currentCompany;
            } else {
                const currentCompany = this.currentUser.company.accountingFirms.find(
                    (x) => x.id === this.companyId,
                );
                if (currentCompany) {
                    this.user.company = currentCompany;
                } else {
                    // eslint-disable-next-line no-debugger
                    debugger;
                }
            }
        }

        emitter.$on("launchTuto", this.startTuto);
    }

    get checkEmailExist() {
        //
        if (typeof this.alreadyExistEmails[this.user.email] === "undefined") {
            return false;
        }
        return this.alreadyExistEmails[this.user.email];
    }

    get displayPasswordInput() {
        return !env.ENABLE_COGNITO;
    }

    get isDeletableUser() {
        return !!this.user.id && !this.isUserWithAccount && !!this.user.cognitoSub;
    }

    async upsert(redirect = true) {
        this.upsertLoading = true;

        //

        if (this.actions) {
            if (!this.userIsSubUser) {
                await this.upsertUser(false /* redirect */);
            } else {
                await this.updateSubUser();
            }
        } else {
            if (!this.userIsSubUser) {
                await this.upsertUser(redirect);
            } else {
                await this.updateSubUser();
            }
        }

        this.reset();
        //
        this.upsertLoading = false;
    }

    reset() {}

    setUserCompany(company) {
        this.user.company = company;
        this.windowStep = "createUser";
    }

    @Apollo({
        query: CHECK_USER_EMAIL,
        variables() {
            return {
                email: this.user.email,
            };
        },
        skip() {
            return (
                !this.user?.email ||
                !this.emailPattern.test(this.user.email) ||
                this.alreadyExistEmails[this.user.email]
            );
        },
        // debounce: 500,
        specificResult({ data, loading }: QueryDto) {
            if (!loading) {
                if (data && data.checkEmail) {
                    //
                    this.alreadyExistEmails = JSON.parse(
                        JSON.stringify({
                            ...this.alreadyExistEmails,
                            [data.checkEmail.email]:
                                data.checkEmail.isAvailable ||
                                data.checkEmail.userId === this.user.id,
                        }),
                    );
                }
            }
        },
    })
    emailAlreadyExist = false;

    alreadyExistEmails = {};

    @Watch("user", { deep: true })
    checkUser() {
        this.$emit("isValid", this.isValid);
    }

    startTuto() {
        emitter.$emit("setTutorialData", [
            {
                ref: document.getElementById("Information"),
                title: "Créer un nouvel utilisateur",
                pages: [
                    {
                        text: "Une fois crée, vous pouvez modifier les données dans différents onglets. Dans « informations » vous retrouvez les données demandées à la création…",
                        position: "right",
                        align: "center",
                    },
                ],
            },
            {
                ref: document.getElementById("Profil"),
                title: "Créer un nouvel utilisateur",
                pages: [
                    {
                        text: "« …l’onglet « Rôle dans la société» permet de définir le profil utilisateur mais aussi d’indiquer si l’utilisateur peut avoir accès au menu « Gestion des Encours » en production.",
                        position: "right",
                        align: "center",
                    },
                ],
            },
            {
                ref: document.getElementById("Complementaires"),
                title: "Créer un nouvel utilisateur",
                pages: [
                    {
                        text: "Pour les « informations complémentaire » il est question de renseigner les coordonnées de l’utilisateur.",
                        position: "right",
                        align: "center",
                    },
                ],
            },
            {
                ref: document.getElementById("Societe"),
                title: "Créer un nouvel utilisateur",
                pages: [
                    {
                        text: "Pour ajouter un utilisateur cliquez ici ",
                        position: "right",
                        align: "center",
                    },
                ],
            },
        ]);
    }

    profileEditionActions = {
        action: new DialogAction(),
    };

    getSiretValue(siret: string) {
        return getSiretValue(siret);
    }

    getSubTitleCompany(company) {
        let subTitle = this.getSiretValue(company.siret);

        const owners = this.owners(company);
        if (owners) {
            if (subTitle) subTitle += " - ";
            subTitle += "Propriétaire(s) : " + owners;
        }
        return subTitle;
    }

    owners(company) {
        let owners = "";
        if (company.companyUsers?.length) {
            for (const cu of company.companyUsers) {
                if (cu.role && cu.user) {
                    if (owners) owners += ", ";
                    owners += getUserDisplayName(cu.user);
                }
            }
        }
        return owners;
    }

    async sendRecoveryCode() {
        if (!this.user?.email) {
            return;
        }
        await this.$apollo.mutate({
            mutation: SEND_RECOVERY_CODE,
            variables: {
                email: this.user.email,
            },
        });
    }

    formatItemTitle(item: { id: string; name: string }) {
        if (!item.id && !item.name) {
            return "";
        } else {
            return `${item.id} - ${item.name}`;
        }
    }

    @Watch("id")
    onIdChanged() {
        // Make sure that the user is set to defaultUser if no id is provided in Dialog version of the component
        // No impact for the page version of the component
        // This is to avoid having the user set to the last user edited
        if (!this.id) {
            this.user = JSON.parse(JSON.stringify(this.defaultUser));
        }
    }
}
